import React, { Fragment } from 'react';
import { Language } from 'src/types/Language';
import { Container, Row, Heading, Alert, Button } from '@digitools/honest-react';
import { Breadcrumb, Breadcrumbs } from '@digitools/honest-ui';
import { renderIcon } from 'src/utils/FileUtils';
import { useHomePageBreadcrumbs } from 'src/components/Breadcrumbs';
import styled from "styled-components";
const StyledTextButton = styled(Button) `
    font-family: "Roboto", helvetica, sans-serif;
    font-weight: 500;
    text-align: left;
    white-space: normal;
    padding: 0;
    &:hover {
        font-weight: 700;
    }
`;
const EmployeeForms = ({ employeeForms, language, errorMessage, getEmployeeForm, closeError, }) => {
    const rows = employeeForms.map((employeeForm, index) => {
        const title = language === Language.ENGLISH ? employeeForm.englishDisplayName : employeeForm.spanishDisplayName;
        const descr = language === Language.ENGLISH ? employeeForm.englishDescription : employeeForm.spanishDescription;
        const divider = employeeForms && employeeForms.length !== (index + 1) ? <hr aria-hidden={'true'}/> : null;
        return (<Fragment key={'form-' + employeeForm.id}>
            <Row>
              <StyledTextButton onClick={() => getEmployeeForm(employeeForm.englishDisplayName, employeeForm.recordType, employeeForm.id)}>
                <span aria-label={employeeForm.type}>{renderIcon(employeeForm.type)}</span> {title} - (
                {language === Language.ENGLISH ? 'Download' : 'Descargar'})
              </StyledTextButton>
            </Row>
            {descr && (<Row style={{ marginTop: 0 }}>
                <div>{descr}</div>
              </Row>)}
            {divider}
          </Fragment>);
    });
    return (<>
            <br />
            <Breadcrumbs>
                {useHomePageBreadcrumbs()}
                <Breadcrumb>{language === Language.ENGLISH ? 'Forms' : 'Formularios'}</Breadcrumb>
            </Breadcrumbs>
            <Heading elemType='h1' style={{ marginBottom: '2rem' }}>{language === Language.ENGLISH ? 'Forms' : 'Formularios'}</Heading>
            <Container>
                {errorMessage && <Alert type='error' closeable={true} onClose={closeError}><strong>Error: </strong>{errorMessage}</Alert>}
                {(!errorMessage && (employeeForms === undefined || employeeForms.length === 0))
            && <Alert type='info'>We could not find any Employee Forms. If you believe this to be in error, please contact us for assistance.</Alert>}
                {rows}
            </Container>
        </>);
};
export default EmployeeForms;
